import { Column, Entity, PrimaryColumn } from 'typeorm'

@Entity({ name: 'TDevice' })
export class TDevice {
  @PrimaryColumn({ unsigned: true })
  DEVICE_ID: number

  @Column({ unsigned: true })
  SERIAL_NUMBER: number

  @Column({ type: 'smallint' })
  HW_VERSION: number

  @Column({ length: 8 })
  WISOL_ID: string

  @Column({ length: 16 })
  WISOL_PAC: string

  @Column({ type: 'tinyint', unsigned: true })
  SIGFOX_REG: number

  @Column({ unsigned: true })
  DEV_PRODUCT_ID: number

  @Column({ length: 4 })
  DATE_CODE: string

  @Column({ unsigned: true })
  LOCATION_ID: number

  @Column({ unsigned: true })
  MSG_SNTS_ID: number // message seq num timestamp id

  @Column({ unsigned: true })
  RUN_ID: number

  @Column({ type: 'tinyint', unsigned: true })
  LIC_COUNT: number // license count

  @Column({ length: 24 })
  DEV_KEY: string // device key

  @Column({ type: 'timestamp' })
  DATE_UPDATE: Date

  @Column({ type: 'timestamp' })
  DATE_CREATE: Date
}
